import {HeatingDTO} from './heating.dto';

export class SimulationResultDTO {
  cost!: number;
  subvention!: number;
  heating: HeatingDTO = new HeatingDTO();
}
